<template>
	<div class="personalSet relative h-full">
		<div class="flex items-center justify-between pb-[6px] bB-03">
			<div class="flex items-center">
				<div @click="navClick(item,index)" v-for="(item,index) in navList" :key="index"
					:class="type==index?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
					class="navTitle cursor-pointer  relative text-[16px] mr-[34px]">
					{{item.title}}
				</div>
			</div>
			<!--  -->
			<div @click="confirmApply()" v-if="is_user_invitation==0"
				class="min-w-[90px] h-[34px] px-[10px] box-border cursor-pointer leading-[34px] text-[14px] text-center text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
				{{langInfo['apply invitation code title']}}
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	export default {
		name: "personalSet",
		data() {
			return {
				type: 0,
				langInfo: {},
				is_user_invitation: 0,
				invitation_code_list: [],
				navList: [{
						title: '', //基础信息
						path: '/personalCenter/personalSet/baseInfo?type=0'
					},

					{
						title: '', //我的邀请码
						path: '/personalCenter/personalSet/myInviteCode?type=1'
					},
					{
						title: '', //我的账户余额
						path: '/personalCenter/personalSet/myAccount?type=2'
					}
				],
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log(to.query.type); // 获取查询参数
				// 你可以在这里处理查询参数的变化
				this.type = to.query.type
			}
		},
		mounted() {
			if (this.$route.query.type) {
				this.type = this.$route.query.type
			}

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.navList[0].title = this.langInfo.basic_infor
				this.navList[1].title = this.langInfo.my_invitation_code
				this.navList[2].title = this.langInfo.balance_account
			}
			this.getUser()
		},
		methods: {
			getUser() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.is_user_invitation = res.data.is_user_invitation || 0
				}).catch((error) => {
					if (error.code == 450) {
						setTimeout(() => {
							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);
							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			get_user_invitation_code_list() {
				this.$api.user_invitation_code_list({}).then((res) => {
					console.log(res);
					this.invitation_code_list = res.data
				}).catch((error) => {})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.navList[0].title = this.langInfo.basic_infor
					this.navList[1].title = this.langInfo.my_invitation_code
					this.navList[2].title = this.langInfo.balance_account
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			navClick(item, index) {
				if (item.path) {
					if (this.$route.fullPath == item.path) {
						// 如果相同则不进行导航
						return;
					}
					this.type = index
					this.$router.push(item.path); // 使用完整路径
				}
			},
			confirmApply() {
				this.$confirm(this.langInfo['apply invitation code tip'], this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.user_invitation_code({}).then((res) => {
						console.log(res);
						this.getUser()
						EventBus.$emit('user_invitation_code', true)
						this.$message({
							message: res.msg,
							type: 'success'
						})
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})

					})
				}).catch(() => {});
			},
		}
	};
</script>

<style scoped>
	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -12px;
		left: 50%;
		transform: translateX(-50%);

	}

	.navTitle:nth-last-child(1) {
		margin-right: 0;
	}
</style>